"use client";

import React, { ReactNode } from 'react';
import { SettingsProvider } from '@/context/SettingsContext';
import { RedirectProvider } from '@/context/RedirectContext';
import { ModalProvider } from '@/context/ModalContext';
import { ScrollProvider } from '@/context/ScrollContext';

interface ProvidersProps {
    children: ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
    return (
        <SettingsProvider>
            <RedirectProvider>
                <ModalProvider>
                    <ScrollProvider>
                        {children}
                    </ScrollProvider>
                </ModalProvider>
            </RedirectProvider>
        </SettingsProvider>
    );
};
